<template>
  <div>
    <v-form ref="form" v-model="valid" class="mt-5">
      <v-row dense no-gutters>
        <v-col cols="12" md="12">
          <v-alert outlined color="info" text class="pa-4 mb-4 body-2"
            >Select the street address you are applying for, or leave it
            blank.</v-alert
          >
        </v-col>
        <v-col cols="12" md="6">
          <!-- <v-combobox
            :items="listings"
            v-model="form.add1"
            no-data-text="Property not found"
            prepend-inner-icon="mdi-home-search"
            outlined
            required
            label="Street Address"
          ></v-combobox> -->
          <v-text-field
            v-model="form.add1"
            prepend-inner-icon="mdi-home"
            outlined
            required
            label="Street Address"
          />
        </v-col>
        <v-col cols="12" md="12">
          <v-alert outlined color="info" text class="pa-4 mb-4 body-2">
            Pet Policy for Alpine Properties - up to 2 pets OK. $25 per month
            per pet. No Pitbulls, please. Pet policy may differ for various
            properties.
          </v-alert>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.pets"
            type="number"
            outlined
            :rules="rules"
            :min="0"
            required
            label="# of Pets"
            persistent-hint
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
    <v-btn color="green" dark @click="submit()">Continue</v-btn>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        add1: "",
        pets: "",
      },
      propertys: [],
      valid: false,
      min: new Date().toISOString().substr(0, 10),
      menu: false,
      rules: [(v) => !!v || "Field is required"],
      emailRules: [
        (v) => !!v || "Field is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
    };
  },
  computed: {
    listings() {
      let list = [];
      let { listings } = this.$store.getters;
      listings.forEach((item) => {
        if (item !== "Unsure") list.push(item);
      });
      return list;
    },
  },
  methods: {
    submit() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.valid) return;
      let form = vm.$store.getters.form;
      form.leaseInfo = vm.form;
      console.log(form);
      vm.$store.commit("setForm", form);
      vm.$emit("step", 2);
    },
  },
  mounted() {
    const vm = this;
    let form = vm.$store.getters.form;
    form.leaseInfo = vm.form;
    vm.$store.commit("setForm", form);
  },
};
</script>

<style></style>
